import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { queryParamsModule } from '@/modules/queryParams';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { useQueryOnboardingCategories } from '@/pages/Onboarding/hooks/useQueryOnboardingCategories';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataKeyType, LayoutDataType } from '../../types';

import { TOPICS_OPTIONS } from './constants';
import './Topics.scss';

export const OnboardingReplikaTopics: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Topics',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const preloadCategories = form.getValues('preloadCategories');

  useQueryOnboardingCategories({
    enabled: preloadCategories.length === 0,
    form,
  });

  const topics = form.watch('topics');

  const handleChange = (option: OnbOptionType<LayoutDataType['topics']>) => {
    userService.createOrUpdate({
      onboarding_data: {
        topics: option.title,
      },
    });
    queryParamsModule.setParam<LayoutDataKeyType>('topics', option.id);
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage className="onboarding-topics">
      <OnboardingNavigation />

      <IonContent>
        <OnboardingTitle className="onboarding-topics__title">
          What are you mostly looking for in Dialogue?
        </OnboardingTitle>
        <OnboardingOptionsList>
          {TOPICS_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={topics === option.id}
              control={form.control}
              option={option}
              name="topics"
              key={option.id}
              onChange={() => handleChange(option)}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
